export const SETTING = {
    BUSINESS: 1,
    DISCHARGE: 2,
    ACCOUNT: 3,
    SERVICE: 4,
    SETTING_AUTO_APPROVAL: 7
}